import { styled } from 'styled-components'

export const EmptyBottom = styled.div`
  visibility: hidden;
  height: 1px;
  width: 1px;
  z-index: -100;
`
